module.exports = __webpack_public_path__ + "static/media/LogoMain.3eb2e247.svg";